import { AddressSuggestionMagentoResponse, AddressSuggestionResponse } from "../interfaces/address-suggestions.interface";

export function mapAddressSuggestionMagento(suggestionMagento: AddressSuggestionMagentoResponse): AddressSuggestionResponse[] {
    const suggestions = suggestionMagento.content;
    return suggestions.map(suggestion => ({
            displayAddress: suggestion.display_address,
            searchText: suggestion.search_text,
            street1: suggestion.street1,
            street2: suggestion.street2,
            city: suggestion.city,
            state: suggestion.state,
            zipCode: suggestion.zip_code,
            entries: suggestion.entries, 
            secondaryExpansion: suggestion.secondary_expansion
    }))  
}